export const required = (parameterValue) =>  {
  return !!parameterValue || `Обязательное поле`;
};
